import Vue from 'vue'
import Vuex from 'vuex'

import auth from './modules/auth'
import common from './modules/common'
import item from './modules/item'
import organization from './modules/organization'
import catalog from './modules/catalog'
import taxonomy from './modules/taxonomy'
import user from './modules/user'
import report from './modules/report'
import planType from './modules/plan_type'
import banner from './modules/banner'
import search from './modules/search'
import montosCotizaciones from './modules/montosCotizaciones'
import organizationContact from './modules/organizationContact'
import workflows from './modules/workflows'
import termsConditions from './modules/termsConditions'
import pay4supply from './modules/pay4supply'
import newsMarketplace from './modules/newsMarketplace'
import hubSuppliers from './modules/hubSuppliers'
import hubSuppliersValidators from './modules/hubSuppliersValidators'
import processes from './modules/processes'
import dashboardTemplate from './modules/dashboardTemplate'
import chatbot from './modules/chatbot'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    common,
    item,
    catalog,
    taxonomy,
    organization,
    newsMarketplace,
    hubSuppliers,
    hubSuppliersValidators,
    dashboardTemplate,
    report,
    planType,
    user,
    banner,
    search,
    montosCotizaciones,
    organizationContact,
    workflows,
    pay4supply,
    termsConditions,
    processes,
    chatbot
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js